<template>
  <Modal name="UPDATE_PROFILE_MODAL" :title="$t('profile.label.edit')" actions>
    <template v-slot:body>
      <v-form ref="userForm" v-model="valid">
        <v-text-field
          v-model="user.name"
          :label="$t('host.label.name')"
          :rules="rules.required"
          outlined
        />
        <v-row>
          <v-col class="py-0">
            <HDocumentID
              v-model="user.cpf"
              :default-value="user.cpf"
              :rules="rules.cpfRule"
            />
          </v-col>
          <v-col class="py-0">
            <v-text-field
              v-model="user.rg"
              :label="$t('host.label.rg')"
              outlined
            />
          </v-col>
        </v-row>
        <HPhone
          v-model="user.phone"
          :default-value="user.phone"
        />
        <v-text-field
          v-model="user.api_token"
          :label="$t('profile.label.apiToken')"
          hide-details="auto"
          outlined
        />
      </v-form>
    </template>
    <template v-slot:actions>
      <v-btn @click="closeAllModals" :disabled="isLoading" elevation="0" class="mr-5" large text>
        {{ $t('profile.updateRealEstate.label.cancel') }}
      </v-btn>
      <v-btn @click="validate" :loading="isLoading" color="primary" elevation="0" large>
        {{ $t('profile.updateRealEstate.label.confirm') }}
      </v-btn>
    </template>
  </Modal>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { required, cpfRule } from '@/util/defaultValidationRules'
import { unmaskText } from '../../util/helpers'

import Modal from '@/components/app/Modal'
import HDocumentID from '../app/HDocumentID'
import HPhone from '../app/HPhone'

export default {
  name: "UpdateProfile",
  components: {
    Modal,
    HDocumentID,
    HPhone,
  },
  data() {
    return {
      valid: false,
      rules: { required, cpfRule }
    }
  },
  computed: { ...mapGetters(['isLoading', 'user']) },
  methods: {
    ...mapActions(['fetchUser', 'updateUserProfile']),
    ...mapMutations(['openModal', 'closeAllModals']),

    buildUpdateProfileRequest() {
      return {
        name: this.user.name,
        phone: this.user.phone,
        cpf: unmaskText(this.user.cpf),
        rg: unmaskText(this.user.rg),
      }
    },

    maskFields() {
      this.user.phone = this.user.phone
      this.user.cpf = this.user.cpf
    },

    validate() {
      if (!this.$refs.userForm.validate()) return
      this.updateUserProfile(this.buildUpdateProfileRequest())
    }
  }
}
</script>
